import PlaceSearch from './PlaceSearch';

export default PlaceSearch;
